(function() {
  'use strict';

  var content = document.querySelector('.article-template__content');
  if (!content) return;

  var headings = content.querySelectorAll('h2, h3');
  if (headings.length < 2) return;

  // Build TOC items
  var items = [];
  headings.forEach(function(heading, index) {
    var text = heading.textContent.trim();
    if (!text) return;

    // Create slug for anchor
    var slug = text
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .substring(0, 60);

    // Ensure unique ID
    var id = slug || 'section-' + index;
    if (document.getElementById(id)) {
      id = id + '-' + index;
    }

    heading.setAttribute('id', id);

    items.push({
      id: id,
      text: text,
      level: heading.tagName.toLowerCase()
    });
  });

  if (items.length < 2) return;

  // Build TOC HTML
  var tocHTML = '<nav class="article-toc" aria-label="Table of contents">';
  tocHTML += '<p class="article-toc__title">';
  tocHTML += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>';
  tocHTML += 'In This Article</p>';
  tocHTML += '<ol class="article-toc__list">';

  items.forEach(function(item) {
    var cssClass = item.level === 'h3' ? ' class="toc-h3"' : '';
    tocHTML += '<li' + cssClass + '><a href="#' + item.id + '">' + item.text + '</a></li>';
  });

  tocHTML += '</ol></nav>';

  // Insert TOC at the beginning of article content
  content.insertAdjacentHTML('afterbegin', tocHTML);

  // Smooth scroll behavior
  var tocLinks = content.querySelectorAll('.article-toc a');
  tocLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      var target = document.getElementById(this.getAttribute('href').substring(1));
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, null, this.getAttribute('href'));
      }
    });
  });
})();
